
export const profileEndpoints = {
    getLocation: "/geolocation/get-location/",
    getWorkDays: '/service/my-workdays/',
    puttWokDayUpdate: "/service/workdays-update/",
    postUpSellingCreate: "/service/upselling-create/",
    getMyServices: "/service/my-services/",
    deleteMyServices: "/service/my-services/",
    editMyServices: "/service/my-services/",
    getClients: "/client/clients-list/",
    getProfileAnalytics: "/client/profile-analytics/",
    getUserView: "/auth/userinfo/",
    getSocialProfile: "/auth/social-profile-view/",
    getClientView: "/client/client-view/",
    getClientLabels: "/client/client-labels/",
    postClientCreate: "/client/client-create/",
    putClientView: "/client/client-view/",
    getUserCurrency: "/service/user-currency/",
    emailChangeRequest: "/auth/email-change-request/",
    emailChangeVerify: "/auth/email-change-verify/",
    deleteInstagramDisconnect: "/auth/instagram-disconnect/",
    deleteWhatsappDisconnect: "/whatsapp/disconnect-whatsapp/",
    postUserInfoWebsite: "/auth/userinfo-website/",
    getUserInfoWebsite: "/auth/userinfo-website/",
    deleteAccountDelete: "/auth/account-delete/",
    getLogout: "/auth/logout/",
    getServiceAdvancedSettings: "/service/service-advanced-settings/",
    postServiceAdvancedUploadImages: "/service/service-advanced-upload-images/",
    potServiceAdvancedUpdateImages: "/service/service-advanced-update-images/",
    postServiceBrandAdd: "/service/service-brand-add/",
    getServiceBrandGet: "/service/service-brand-get/",
    potServiceAdvancedUpdateBrands: "/service/service-brand-update/",
    deleteServiceBrandDelete: "/service/service-brand-delete/",
    postMyServicesToggleOnOff: "/service/my-services-toggle-on-off/",
    postMyServicesUpdateCount: "/service/my-services-update-count/",
    getClientExcelFile: "/client/client-excel-file/",
    getServiceExcelFile: "/service/service-excel-file/",
    postUploadClientsExcel: "/client/upload-clients-excel/",
    postUploadServicesExcel: "/service/upload-service-excel/", 
    postRateApp: "/apprate/rate-app/",
    getRateApp: "/apprate/rate-app/",
    getStories: "/story/stories/",
    getCheckAddress: "/auth/check-address/",
    deleteWorker: "/auth/delete-worker/",
    getAppointmentHistoryByClient: "/client/client-view/",
    getIndustry: "/auth/get-industry/",
    getProfessionCategories: "/marketplace/profession-categories/",
    putUserInfo: "/auth/userinfo/",


};
